import { ComplianceStatus, ComplianceStatusLabel } from '@evidentid/tprm-portal-lib/models/entity-details';

import { CategorizedEnumLabels } from '@/modules/dashboard/models/CategorizedEnumLabels.model';
import { EnumCategories } from '@/modules/dashboard/models/EnumCategories.model';
import { escapeHtml } from '@/modules/entity-events/utils/escapeHtml';

const LOCAL_COMPLIANCE_STATUS_LABELS: Record<string, string> = Object.entries(ComplianceStatus)
    .reduce((acc, [ key, value ]) => ({
        ...acc,
        [value]: (ComplianceStatusLabel as Record<string, string>)[key],
    }), {} as Record<string, string>);

/**
 * Resolves a raw complianceStatus value to a display label: backend enum labels first, then the local
 * New/Pending/Compliant/Non-Compliant mapping, then the raw value itself for unknown or deprecated statuses.
 * The result is HTML-escaped since it's rendered via v-html in ActivityHistoryTableRow.
 */
export function resolveComplianceStatusLabel(status: string, enumLabels: CategorizedEnumLabels): string {
    const backendLabels = enumLabels[EnumCategories.complianceStatus] || {};
    const label = backendLabels[status]?.label || LOCAL_COMPLIANCE_STATUS_LABELS[status] || status;
    return escapeHtml(label);
}
